import { DateTimeFormatter } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';

function DateTimeCell(props) {
  const { cell, type } = props;

  const getType = () => {
    if (cell?.column?.onlyDate) {
      return 'date';
    }
    return 'dateTime';
  };

  return cell.value ? (
    <DateTimeFormatter type={getType()} date={cell.value} />
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default DateTimeCell;
